import api from '@/api'
export default {
  
  getSupervisoryListBySystem (params) {
    return api({
      url: '/supervisory/supervisoryTrainListSystem',
      method: 'GET',
      params
    })
  },
  getSupervisoryListByExpert (params) {
    return api({
      url: '/supervisory/supervisoryTrainListExpert',
      method: 'GET',
      params
    })
  },
  // 添加训练督导
  addSupervisory (data) {
    return api({
      url: '/supervisory/supervisoryTrainAdd',
      method: 'POST',
      data
    })
  },
  // 添加训练督导
  editSupervisory (data) {
    return api({
      url: '/supervisory/supervisoryTrainEdit',
      method: 'POST',
      data
    })
  },
  getSupervisoryInfo (uuid) {
    return api({
      url: `/supervisory/supervisoryTrainView/${uuid}`,
      method: 'GET'
    })
  },
  deleteSupervisory(uuid) {
    return api({
      url: `/supervisory/supervisoryTrainRemove/${uuid}`,
      method: 'POST'
    })
  },
  
  getSupervisoryMatchListBySystem (params) {
    return api({
      url: '/supervisory/supervisoryMatchListSystem',
      method: 'GET',
      params
    })
  },
  getSupervisoryMatchListByExpert (params) {
    return api({
      url: '/supervisory/supervisoryMatchListExpert',
      method: 'GET',
      params
    })
  },
  // 添加训练督导
  addMatchSupervisory (data) {
    return api({
      url: '/supervisory/supervisoryMatchAdd',
      method: 'POST',
      data
    })
  },
  // 添加训练督导
  editMatchSupervisory (data) {
    return api({
      url: '/supervisory/supervisoryMatchEdit',
      method: 'POST',
      data
    })
  },
  getMatchSupervisoryInfo (uuid) {
    return api({
      url: `/supervisory/supervisoryMatchView/${uuid}`,
      method: 'GET'
    })
  },
  deleteMatchSupervisory(uuid) {
    return api({
      url: `/supervisory/supervisoryMatchRemove/${uuid}`,
      method: 'POST'
    })
  },
  downloadSupervisoryTrainFile (uuid) {
    return api({
      url: `/supervisory/downloadSupervisoryTrainFile/${uuid}`,
      method: 'GET'
    })
  },
  uploadSupervisoryTrainFile(data) {
    return api({
      url: '/supervisory/uploadSupervisoryTrainFile',
      method: 'POST',
      data
    })
  },
  downloadSupervisoryMatchFile (uuid) {
    return api({
      url: `/supervisory/downloadSupervisoryMatchFile/${uuid}`,
      method: 'GET'
    })
  },
  supervisoryPersonList () {
    return api({
      url: `/supervisory/supervisoryPersonList`,
      method: 'GET'
    })
  },
  uploadSupervisoryMatchFile(data) {
    return api({
      url: '/supervisory/uploadSupervisoryMatchFile',
      method: 'POST',
      data
    })
  },
  supervisoryTrainDownLoadPdf (params) {
    return api({
      url: `/supervisory/supervisoryTrainDownLoadPdf`,
      method: 'GET',
      params
    })
  },
  supervisoryMatchDownLoadPdf (params) {
    return api({
      url: `/supervisory/supervisoryMatchDownLoadPdf`,
      method: 'GET',
      params
    })
  },
}
